import { useContext } from 'react';
import { NotificationContext } from '../context/NotificationProvider';
import { useNavigate } from 'react-router-dom';
import {
  IconButton,Tooltip
} from '@mui/material';
import NotificationsNoneIcon from '@mui/icons-material/NotificationsNone';
export default function NotificheBadge() {
  const context = useContext(NotificationContext);
  const navigate = useNavigate();
    console.log("NotificationContext 1",context);
    if(!context) return <div>NotificationContext non disponibile</div>;
  const { notifications } = context;
  console.log("NotificheBadge notifications",notifications);
  const unreadCount = notifications.filter((n) => !n.letto).length;
 console.log("NotificheBadge unreadCount",unreadCount);
  return unreadCount > 0 ? (
    <div className="notifiche-badge">
      Ci sono {unreadCount} notifiche non lette
                      <Tooltip title="vai alle notifiche">
                        <IconButton size="small" onClick={() => navigate(`/notifiche`)}><NotificationsNoneIcon /></IconButton>
                       </Tooltip>
    </div>
  ) : null;
}